import { Component, Vue } from 'vue-property-decorator';
import WithRender from './breadcrumb.html';

// models
import { BreadCrumbModel } from '@/models/breadcrumb';
import { moduleProxy } from '@/store';

@WithRender
@Component
export default class BreadCrumb extends Vue {
  get breadcrumbs(): BreadCrumbModel[] {
    return moduleProxy.BreadCrumb.breadcrumbs;
  }
}
